var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.64,
    height: 31.94,
    viewBox: "0 0 31.64 31.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31955",
    "data-name": "Group 31955",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20737",
    "data-name": "Rectangle 20737",
    width: 31.64,
    height: 2.001,
    transform: "translate(0 14.92)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20738",
    "data-name": "Rectangle 20738",
    width: 2,
    height: 5.34,
    transform: "translate(16.9 7.32)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20739",
    "data-name": "Rectangle 20739",
    width: 2,
    height: 8.9,
    transform: "translate(23.23 3.76)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20740",
    "data-name": "Rectangle 20740",
    width: 2,
    height: 12.66,
    transform: "translate(29.55 0)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20741",
    "data-name": "Rectangle 20741",
    width: 2,
    height: 5.341,
    transform: "translate(12.74 19.28)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20742",
    "data-name": "Rectangle 20742",
    width: 2,
    height: 8.9,
    transform: "translate(6.41 19.28)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20743",
    "data-name": "Rectangle 20743",
    width: 2,
    height: 12.66,
    transform: "translate(0.09 19.28)",
    fill: "#444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.e4ba59622a683a3f3c396174eebea97a.svg";
export { ForwardRef as ReactComponent };